export default __webpack_public_path__ + "static/media/landing-Word-Objeto4.358ac119.webp";